<template>
    <section id="theme_search_form">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="theme_search_form_area">
                        <div class="theme_search_form_tabbtn">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="hotels-tab" data-bs-toggle="tab"
                                        data-bs-target="#hotels" type="button" role="tab" aria-controls="hotels"
                                        aria-selected="false"><i class="fas fa-hotel"></i>{{ $t('Hotels') }}</button>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="hotels" role="tabpanel" aria-labelledby="hotels-tab">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="tour_search_form">
                                            <div class="row">
                                                <div class="col-lg-4 col-md-12 col-sm-12 col-12">
                                                    <div class="flight_Search_boxed">
                                                        <p>{{ $t('Destination') }}</p>
                                                        <input type="text" :placeholder="$t('Type your destination, hotel')"
                                                            :value="$t('Riyadh')" readonly>
                                                        <span></span>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                                                    <div class="form_search_date">
                                                        <div class="flight_Search_boxed date_flex_area">
                                                            <div class="Journey_date">
                                                                <p>{{ $t('Check-in') }}</p>
                                                                <VueDatePicker v-model="date" :enable-time-picker="false"
                                                                    :min-date="departure_min_date"
                                                                    :max-date="departure_max_date"
                                                                    @update:model-value="handleDate"
                                                                    :placeholder="$t('Select date')" />
                                                                <span class="departure_day"></span>
                                                            </div>
                                                            <div class="Journey_date">
                                                                <p>{{ $t('Check-out') }}</p>
                                                                <VueDatePicker v-model="arrival_date"
                                                                    :enable-time-picker="false" :min-date="arrival_min_date"
                                                                    :max-date="arrival_max_date"
                                                                    @update:model-value="arrivalHandleDate"
                                                                    :placeholder="$t('Select date')" />
                                                                <span class="arrival_day"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-3  col-md-6 col-sm-12 col-12">
                                                    <div class="flight_Search_boxed dropdown_passenger_area">
                                                        <p>{{ rnumber }} {{ $t('rooms for') }}</p>
                                                        <div class="dropdown">
                                                            <button class="dropdown-toggle final-count"
                                                                data-toggle="dropdown" type="button"
                                                                id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                                                aria-expanded="false">
                                                                {{ number }} {{ $t('guest') }}
                                                            </button>

                                                            <div class="dropdown-menu dropdown_passenger_info"
                                                                aria-labelledby="dropdownMenuButton1">
                                                                <div class="traveller-calulate-persons">
                                                                    <div v-for="(room, key) in searchRooms"
                                                                        class="passengers">
                                                                        <div class="passengers-types d-flex">
                                                                            <div v-if="key == 0" class="passengers-type">
                                                                                <div class="type-label">
                                                                                    <p>{{ $t('Rooms') }}</p>
                                                                                </div>
                                                                                <div class="text">
                                                                                    <button type="button" class="btn-add"
                                                                                        @click.stop="incrementroom">
                                                                                        <i class="fas fa-plus"></i>
                                                                                    </button>
                                                                                    <span class="count pcount">
                                                                                        {{
                                                                                            rnumber
                                                                                        }}
                                                                                    </span>
                                                                                    <button type="button"
                                                                                        class="btn-subtract"
                                                                                        @click.stop="decrementroom">
                                                                                        <i class="fas fa-minus"></i>
                                                                                    </button>

                                                                                </div>
                                                                            </div>
                                                                            <div v-else class="passengers-type">
                                                                                <div class="type-label">
                                                                                    <p></p>
                                                                                </div>
                                                                                <div class="text-center">
                                                                                    {{ $t('Room') }} {{ key + 1 }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="passengers-type">
                                                                                <p class="fz14 mb-xs-0">
                                                                                    {{ $t('Adults') }}
                                                                                </p>
                                                                                <div class="text">
                                                                                    <button type="button" class="btn-add-c"
                                                                                        @click.stop="increment(key)">
                                                                                        <i class="fas fa-plus"></i>
                                                                                    </button>
                                                                                    <span class="count ccount">
                                                                                        {{
                                                                                            room.adult
                                                                                        }}
                                                                                    </span>
                                                                                    <button type="button"
                                                                                        class="btn-subtract-c"
                                                                                        @click.stop="decrement(key)">
                                                                                        <i class="fas fa-minus"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <div class="passengers-type">
                                                                                <p class="fz14 mb-xs-0">
                                                                                    {{ $t('Children') }}
                                                                                </p>
                                                                                <div class="text">
                                                                                    <button type="button" class="btn-add-in"
                                                                                        @click.stop="incrementc(key)">
                                                                                        <i class="fas fa-plus"></i>
                                                                                    </button>
                                                                                    <span class="count incount">{{
                                                                                        room.child
                                                                                    }}</span>
                                                                                    <button type="button"
                                                                                        class="btn-subtract-in"
                                                                                        @click.stop="decrementc(key)">
                                                                                        <i class="fas fa-minus"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="children-age">
                                                                            <div v-for="(child, key1) in room.child"
                                                                                class="form-group">
                                                                                <label for="">
                                                                                    {{ $t('Child') }}
                                                                                    {{ key1 + 1 }}
                                                                                    {{ $t('Age') }}
                                                                                </label>
                                                                                <select class="form-control"
                                                                                    v-model="room.childAge[key1]">
                                                                                    <option v-for="i in 12" :value="i"
                                                                                        :selected="i == 1 ? true : false">
                                                                                        {{ i }}
                                                                                    </option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="top_form_search_button">
                                                    <button class="btn btn_theme btn_md" @click.stop="search_hotel">{{
                                                        $t('Search Hotel')
                                                    }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
var that;
import $ from 'jquery';
import { toast } from 'vue3-toastify';
export default {
    name: "Form",
    data() {
        return {
            date: null,
            arrival_date: null,
            searchRooms: [
                {
                    room: 1,
                    adult: 1,
                    child: 0,
                    childAge: []
                },
            ],
            rnumber: 1,
            number: 1,
            pnumber: 1,
            cnumber: 0,
            children_ages: [],
            allowed_companion_numbers: 5,
            max_free_period_between_arrival_departure: 0,
            departure_time_condition: 0,
            arrival_time_condition: 0,
            arrival_start_date: '',
            arrival_end_date: '',
            departure_start_date: '',
            departure_end_date: '',
            allowedDegree: [],
            departure_min_date: new Date(),
            departure_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
            arrival_min_date: new Date(),
            arrival_max_date: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
        };
    },
    methods: {
        handleDate(date) {
            var date = new Date(date);
            var day = date.toLocaleDateString('en-US', { weekday: 'long' });
            $('.departure_day').html(that.$t(day));
        },
        arrivalHandleDate(date) {
            var date = new Date(date);
            var day = date.toLocaleDateString('en-US', { weekday: 'long' });
            $('.arrival_day').html(that.$t(day));
        },
        incrementroom() {
            if ((parseInt(this.rnumber)) < 6) {
                this.rnumber++;
                this.searchRooms.push({
                    room: 1,
                    adult: 1,
                    child: 0,
                    childAge: []
                });
            } else {
                toast.error(this.$t('Rooms cannot be greater than 6'), {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrementroom() {
            if (this.rnumber === 1) return
            this.rnumber -= 1
            this.searchRooms.pop();
        },
        increment(index) {
            if ((parseInt(this.searchRooms[index].adult)) < 6) {
                this.number++;
                this.searchRooms[index].adult++;
            } else {
                toast.error(this.$t('The maximum number of guests has been reached'), {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrement(index) {
            if (!(this.searchRooms[index].adult > this.searchRooms[index].child)) return
            if (this.searchRooms[index].adult === 1) return
            this.searchRooms[index].adult -= 1
            if (this.number === 0) return
            this.number -= 1
        },
        incrementc(index) {
            if ((parseInt(this.searchRooms[index].child)) < 6) {
                this.number++;
                this.searchRooms[index].child++;
                this.searchRooms[index].childAge.push(1);
            } else {
                toast.error(this.$t('The maximum number of guests has been reached'), {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrementc(index) {

            if (this.searchRooms[index].child === 0) return
            this.searchRooms[index].child -= 1

            if (this.number === 0) return
            this.number -= 1
        },
        dateDiffInDays(date1, date2) {
            const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
            const timeDiff = utcDate2 - utcDate1;
            const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
            return daysDiff;
        },
        isDateBetween(dateToCheck, startDate, endDate) {
            return dateToCheck >= startDate && dateToCheck <= endDate;
        },
        format_date(inputDate) {
            var parts = inputDate.split('/');
            var day = parts[0];
            var month = parts[1];
            var year = parts[2];
            return year + '-' + month + '-' + day;
        },
        search_hotel() {
            var destination = $(this).parent().parent().find('.destination').val(),
                date = new Date(this.date).toLocaleDateString('sv-SE'),
                ret_date = new Date(this.arrival_date).toLocaleDateString('sv-SE'),
                adults = this.pnumber,
                children = this.cnumber,
                rooms = this.rnumber;
            const differenceInDays = this.dateDiffInDays(new Date(this.date), new Date(that.arrival_date));
            const isArrivalBetween = this.isDateBetween(new Date(this.date).toLocaleDateString('sv-SE'), new Date(that.format_date(that.arrival_start_date)).toLocaleDateString('sv-SE'), new Date(that.format_date(that.arrival_end_date)).toLocaleDateString('sv-SE'));
            const isDateBetween = this.isDateBetween(new Date(this.arrival_date).toLocaleDateString('sv-SE'), new Date(that.format_date(that.departure_start_date)).toLocaleDateString('sv-SE'), new Date(that.format_date(that.departure_end_date)).toLocaleDateString('sv-SE'));
            // if (destination == '') {
            //     toast.error(this.$t('Invalid Location'), {
            //         autoClose: 2500,
            //         position: toast.POSITION.TOP_RIGHT,
            //         closeButton: true
            //     });
            // } else if (this.date == null || this.arrival_date == null) {
            //     toast.error(this.$t('Invalid Date'), {
            //         autoClose: 2500,
            //         position: toast.POSITION.TOP_RIGHT,
            //         closeButton: true
            //     });
            // } else if (differenceInDays > this.max_free_period_between_arrival_departure) {
            //     toast.error(this.$t('The maximum period between the date of arrival and departure must not exceed') + that.max_free_period_between_arrival_departure + ' ' + that.$t('day'), {
            //         autoClose: 2500,
            //         position: toast.POSITION.TOP_RIGHT,
            //         closeButton: true
            //     });
            // } else if (this.arrival_time_condition && !isArrivalBetween) {
            //     toast.error(this.$t('The date of going to Riyadh must be between two dates') + that.arrival_start_date + that.$t('And date') + that.arrival_end_date, {
            //         autoClose: 2500,
            //         position: toast.POSITION.TOP_RIGHT,
            //         closeButton: true
            //     });
            // } else if (this.departure_time_condition && !isDateBetween) {
            //     toast.error(this.$t('The date of departure from Riyadh must be between the dates') + that.departure_start_date + that.$t('And date') + that.departure_end_date, {
            //         autoClose: 2500,
            //         position: toast.POSITION.TOP_RIGHT,
            //         closeButton: true
            //     });
            // } else {
            var data = {
                "destination": destination,
                "date": date,
                "ret_date": ret_date,
                "currency": 'SAR',
                "adults": adults,
                "children": children,
                "rooms": rooms,
            };
            localStorage.setItem("searchData", JSON.stringify(data));
            this.$router.replace(`/hotel-search`);
            //}
        },
        Jquery() {

        }
    },
    mounted() {
        that = this;
        this.Jquery();
        $('.pre-loader').show();
        $('.pre-loader').hide();
    }
};
</script>